import React from 'react';

export default function PromptBubble({ text }) {
  return (
    <div className="anim-fade-in-up" style={bubbleStyle}>
      <p style={textStyle}>{text}</p>
      {/* tail */}
      <div style={tailStyle}/>
    </div>
  );
}

const bubbleStyle = {
  position: 'relative',
  background: 'white',
  border: '4px solid #111',
  borderRadius: 20,
  padding: '14px 20px',
  boxShadow: '4px 4px 0 #111',
  maxWidth: 280,
  textAlign: 'center',
};

const textStyle = {
  fontFamily: "'Fredoka One', cursive",
  fontSize: '1.2rem',
  color: '#111',
  margin: 0,
};

const tailStyle = {
  position: 'absolute',
  bottom: -18,
  left: '50%',
  transform: 'translateX(-50%)',
  width: 0,
  height: 0,
  borderLeft: '10px solid transparent',
  borderRight: '10px solid transparent',
  borderTop: '18px solid #111',
};
